import { ArcheLayout } from '../../../components/ArcheLayout';
import { FavoritesPage } from './FavoritesPage';

export function FavoritesArchePage() {
  return (
    <ArcheLayout>
      <FavoritesPage />
    </ArcheLayout>
  );
}
